import { renderCableCols } from "./10_cable";
import { renderMleCols } from "./11_mle";
import { renderSensorCols } from "./11.5_sensor";
import { renderControllerCols } from "./12_controller";
import { renderStepUpXfmrCols } from "./13_su_xfmr";
import { renderStepDownXfmrCols } from "./13.5_sd_xfmr";
import { renderBoltOnDischargeCols } from "./13.75_bolt_on_discharges";
import { renderPumpCols } from "./14_pump";
import { renderSizingInfoCols } from "./1_sizing_info";
import { renderWellCompletionCols } from "./2_well_completion";
import { renderWellTestCols } from "./3_well_test";
import { renderFluidPropertiesCols } from "./4_fluid_properties";
import { renderCorrelationsCols } from "./5_correlations";
import { renderYToolCols } from "./5.5_y_tool";
import { renderViscosityTestsCols } from "./6_viscosity_tests";
import { renderWellTargetCols } from "./6.5_well_target";
import { renderPumpIntakeCalcsCols } from "./7_pump_intake_calcs";
import { renderIntakeGasSeparatorCols } from "./7.5_intake_gas_separator";
import { renderMotorCols } from "./8_motor";
import { renderSealCols } from "./9_seal";
import type { RenderScenarioExportCols } from "./sizingExportTypes";

/**
 * The order of the sections in a sizing export. The numeric filename prefixes
 * are documentation only. This array is the real order.
 */
export const exportSectionOrder: RenderScenarioExportCols[] = [
  renderSizingInfoCols,
  renderWellCompletionCols,
  renderWellTestCols,
  renderFluidPropertiesCols,
  renderCorrelationsCols,
  renderYToolCols,
  renderViscosityTestsCols,
  renderWellTargetCols,
  renderPumpIntakeCalcsCols,
  renderIntakeGasSeparatorCols,
  renderMotorCols,
  renderSealCols,
  renderCableCols,
  renderMleCols,
  renderSensorCols,
  renderStepDownXfmrCols,
  renderControllerCols,
  renderStepUpXfmrCols,
  renderBoltOnDischargeCols,
  renderPumpCols
];

/**
 * HPS exports omit these sections. An earlier version removed them with
 * positional splice arithmetic, so a new section shifted the indices and
 * omitted the wrong sections. This list is the exact set that the splice calls
 * removed, so the behaviour is unchanged.
 *
 * The bolt-on discharge is not in this list. HPS sizings can have a discharge,
 * and the catalog has an `is_hps` flag for them.
 */
export const hpsOmittedSections: RenderScenarioExportCols[] = [
  renderWellCompletionCols,
  renderYToolCols,
  renderViscosityTestsCols,
  renderSealCols,
  renderCableCols,
  renderMleCols
];

/** Returns the sections to render, in order, for one sizing. */
export function getExportSections(isHPS: boolean): RenderScenarioExportCols[] {
  return exportSectionOrder.filter(
    renderColsFn => !isHPS || !hpsOmittedSections.includes(renderColsFn)
  );
}
